import { render, staticRenderFns } from "./FindAdmin.vue?vue&type=template&id=9f9556ae&"
import script from "./FindAdmin.vue?vue&type=script&lang=ts&"
export * from "./FindAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports